export default "__VITE_PUBLIC_ASSET__76af6bb9__"